import { Input } from 'antd';
import React, { useState } from 'react';

const PasswordInput = ({
  placeholder,
  password,
  onChange,
  isValid
}) => {
  const [hasTouchedInput, setHasTouchedInput] = useState(false);
  const handleTouchInput = () => setHasTouchedInput(true);
  const displayErrorMsg = hasTouchedInput && !isValid;
  return (
    <>
      <Input.Password
        type="password"
        placeholder={placeholder}
        size="middle"
        value={password}
        onChange={onChange}
        onFocus={handleTouchInput}
        onClick={handleTouchInput}
        status={displayErrorMsg ? 'error' : undefined}
      />
      {displayErrorMsg && <p className="text-regular my-1 text-flexi-red">Votre mot de passe doit contenir au moins 8 caractères dont au moins une majuscule, un chiffre et un symbole.</p>}
    </>
  );
};

export default PasswordInput;
